var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 83,
    viewBox: "0 0 313 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9038 12.076C31.6097 10.8533 30.1825 8.70779 27.716 7.28374C25.2496 5.8597 22.6779 5.69643 21.972 6.91905C21.2661 8.14168 22.6933 10.2872 25.1597 11.7113C27.6262 13.1353 30.1979 13.2986 30.9038 12.076Z",
    fill: "#FFD29E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.376 11.3313C42.9675 10.5715 42.1002 8.90698 40.4388 7.61359C38.7774 6.3202 36.951 5.8877 36.3594 6.64757C35.7679 7.40744 36.6352 9.07194 38.2966 10.3653C39.958 11.6587 41.7844 12.0912 42.376 11.3313Z",
    fill: "#FFD29E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5111 15.4149C53.0193 14.8623 52.3697 13.438 51.0602 12.2338C49.7506 11.0296 48.277 10.5014 47.7688 11.054C47.2606 11.6067 47.9102 13.0309 49.2198 14.2351C50.5293 15.4394 52.0029 15.9676 52.5111 15.4149Z",
    fill: "#FFD29E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5967 22.0834C22.3176 19.8379 19.7969 17.0206 15.9663 15.7907C12.1358 14.5608 8.4461 15.384 7.72512 17.6295C7.00414 19.875 9.52493 22.6923 13.3554 23.9222C17.186 25.1521 20.8757 24.3289 21.5967 22.0834Z",
    fill: "#FFD29E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1614 42.7519C22.6925 39.0932 18.4803 36.6182 13.753 37.224C9.02578 37.8297 5.57364 41.2868 6.04247 44.9455C6.5113 48.6043 10.7236 51.0793 15.4508 50.4735C20.1781 49.8678 23.6302 46.4107 23.1614 42.7519Z",
    fill: "#FFD29E"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6254 66.0659C73.0016 65.5293 73.2976 62.9924 72.2866 60.3997C71.2756 57.807 69.3405 56.1402 67.9642 56.6768C66.588 57.2134 66.292 59.7503 67.303 62.343C68.314 64.9357 70.2492 66.6025 71.6254 66.0659Z",
    fill: "#FFD29E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8576 75.4995C35.3488 76.7153 39.4302 74.1085 40.9735 69.677C42.5168 65.2455 40.9377 60.6674 37.4465 59.4515C33.9552 58.2357 29.8739 60.8424 28.3305 65.274C26.7872 69.7055 28.3663 74.2836 31.8576 75.4995Z",
    fill: "#FFD29E"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9622 78.1582C61.2947 77.8096 62.7211 74.4192 62.1482 70.5855C61.5752 66.7518 59.2199 63.9265 56.8874 64.2751C54.5549 64.6237 53.1285 68.0141 53.7014 71.8478C54.2744 75.6815 56.6297 78.5067 58.9622 78.1582Z",
    fill: "#FFD29E"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_875_7375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.583 24.3906H38.6557L41.8994 36.2762L44.9724 24.3906H51.6307L55.187 36.2835L57.606 24.3906H64.9471L59.1425 49.9773H52.4842L48.5436 34.9437L43.7773 49.9773H36.0948L30.9731 28.0224H28.583V24.3906Z",
    fill: "#FFD29E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8049 49.8866L66.7236 24.3906H85.7318L84.1194 31.9531L72.4489 31.7989L71.9955 33.5824L83.5282 33.7266L81.9981 40.2294L70.5573 40.0903L69.9662 42.1768L88.7444 42.142L86.9079 49.8866H60.8049Z",
    fill: "#FFD29E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4324 40.2635L87.7806 24.39L108.026 23.9069L109.364 22.6797L110.513 23.8748H111L109.399 31.5024L92.6994 31.4769L92.1125 33.6949L108.934 33.7394L105.764 49.886H88.3496L90.1139 42.0577L100.201 41.9054L100.675 40.0724L84.4324 40.2635Z",
    fill: "#FFD29E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.7473 36.5451 133.7887 48.1726H130.9812L129.4065 42.0646Q129.3588 41.8896 129.2792 41.5317Q129.1997 41.1738 129.1122 40.7483Q129.0247 40.3229 128.9571 39.9451Q128.8895 39.5673 128.8657 39.3446Q128.8418 39.5673 128.7742 39.9411Q128.7066 40.3149 128.6231 40.7364Q128.5396 41.1579 128.4601 41.5238Q128.3805 41.8896 128.3328 42.0805L126.766 48.1726H123.9665L121 36.5451H123.4257L124.913 42.8917Q124.9766 43.178 125.0601 43.5757Q125.1436 43.9734 125.2271 44.4068Q125.3106 44.8402 125.3782 45.2419Q125.4458 45.6435 125.4776 45.9378Q125.5174 45.6356 125.581 45.2339Q125.6446 44.8323 125.7202 44.4148Q125.7958 43.9972 125.8753 43.6393Q125.9548 43.2814 126.0184 43.0587L127.7125 36.5451H130.0427L131.7368 43.0587Q131.7924 43.2735 131.868 43.6353Q131.9436 43.9972 132.0231 44.4187Q132.1026 44.8402 132.1702 45.2419Q132.2378 45.6435 132.2696 45.9378Q132.3253 45.5401 132.4247 44.9715Q132.5241 44.4028 132.6395 43.8381Q132.7548 43.2735 132.8423 42.8917L134.3215 36.5451ZM144.9072 48.1726H138.2106V36.5451H144.9072V38.5652H140.6761V41.1182H144.6129V43.1383H140.6761V46.1366H144.9072ZM154.1965 44.9436Q154.1965 45.9775 153.6955 46.7411Q153.1944 47.5046 152.236 47.9181Q151.2777 48.3317 149.9097 48.3317Q149.3053 48.3317 148.7287 48.2522Q148.1521 48.1726 147.6232 48.0175Q147.0943 47.8624 146.6171 47.6318V45.3413Q147.4443 45.7071 148.335 46.0014Q149.2258 46.2957 150.1006 46.2957Q150.7051 46.2957 151.0749 46.1366Q151.4447 45.9775 151.6117 45.6992Q151.7787 45.4208 151.7787 45.0629Q151.7787 44.6255 151.4845 44.3153Q151.1902 44.0052 150.6772 43.7348Q150.1643 43.4643 149.52 43.1542Q149.1144 42.9633 148.6372 42.6889Q148.1601 42.4145 147.7306 42.0169Q147.3011 41.6192 147.0267 41.0506Q146.7523 40.4819 146.7523 39.6866Q146.7523 38.6447 147.2295 37.9051Q147.7067 37.1654 148.5935 36.7718Q149.4803 36.3781 150.6892 36.3781Q151.5958 36.3781 152.419 36.5888Q153.2421 36.7996 154.1408 37.1973L153.3455 39.114Q152.5422 38.7879 151.906 38.6089Q151.2697 38.43 150.6096 38.43Q150.1483 38.43 149.8223 38.5771Q149.4962 38.7243 149.3292 38.9907Q149.1622 39.2571 149.1622 39.6071Q149.1622 40.0206 149.4047 40.303Q149.6473 40.5853 150.1364 40.8478Q150.6255 41.1102 151.3572 41.4602Q152.248 41.8817 152.8803 42.339Q153.5125 42.7963 153.8545 43.4127Q154.1965 44.029 154.1965 44.9436ZM167.6533 48.1726 166.8102 45.4049H162.5712L161.7281 48.1726H159.0718L163.1756 36.4974H166.1899L170.3096 48.1726ZM166.2217 43.3371 165.3787 40.633Q165.2991 40.3626 165.1679 39.9371Q165.0367 39.5116 164.9054 39.0702Q164.7742 38.6288 164.6947 38.3027Q164.6151 38.6288 164.476 39.11Q164.3368 39.5912 164.2095 40.0206Q164.0823 40.4501 164.0266 40.633L163.1915 43.3371ZM179.7421 39.281V48.1726H177.881L177.5549 47.0353H177.4277Q177.1414 47.4887 176.7119 47.775Q176.2824 48.0613 175.7655 48.1965Q175.2485 48.3317 174.6918 48.3317Q173.7374 48.3317 173.0296 47.9937Q172.3218 47.6557 171.9281 46.9399Q171.5344 46.2241 171.5344 45.0788V39.281H173.9601V44.4744Q173.9601 45.4288 174.3021 45.9139Q174.6441 46.3991 175.3917 46.3991Q176.1313 46.3991 176.5528 46.0611Q176.9744 45.723 177.1454 45.0669Q177.3164 44.4108 177.3164 43.4643V39.281ZM188.4905 45.5322Q188.4905 46.4388 188.0651 47.0632Q187.6396 47.6875 186.7965 48.0096Q185.9535 48.3317 184.6969 48.3317Q183.7664 48.3317 183.1023 48.2124Q182.4382 48.0931 181.7622 47.8147V45.8105Q182.4859 46.1366 183.317 46.3474Q184.1481 46.5581 184.7764 46.5581Q185.4842 46.5581 185.7904 46.3474Q186.0966 46.1366 186.0966 45.7946Q186.0966 45.5719 185.9734 45.393Q185.8501 45.214 185.4445 44.9874Q185.0389 44.7607 184.172 44.3949Q183.3369 44.0449 182.8001 43.687Q182.2632 43.3291 182.0047 42.84Q181.7463 42.3509 181.7463 41.5954Q181.7463 40.3626 182.7046 39.7383Q183.663 39.114 185.2695 39.114Q186.0966 39.114 186.8482 39.281Q187.5998 39.448 188.3951 39.8138L187.6634 41.5635Q187.0033 41.2772 186.4187 41.0943Q185.8342 40.9114 185.2297 40.9114Q184.6969 40.9114 184.4265 41.0545Q184.1561 41.1977 184.1561 41.492Q184.1561 41.7067 184.2953 41.8737Q184.4344 42.0407 184.8361 42.2435Q185.2377 42.4463 186.0171 42.7645Q186.7727 43.0746 187.3294 43.4127Q187.8861 43.7507 188.1883 44.2477Q188.4905 44.7448 188.4905 45.5322ZM194.1293 46.3991Q194.527 46.3991 194.9048 46.3195Q195.2825 46.24 195.6563 46.1207V47.9261Q195.2666 48.101 194.69 48.2164Q194.1134 48.3317 193.4295 48.3317Q192.6341 48.3317 192.0019 48.0732Q191.3696 47.8147 191.0077 47.1745Q190.6459 46.5343 190.6459 45.389V41.1023H189.4847V40.0763L190.8208 39.2651L191.5207 37.3881H193.0716V39.281H195.5609V41.1023H193.0716V45.389Q193.0716 45.898 193.3619 46.1485Q193.6521 46.3991 194.1293 46.3991ZM202.4165 39.114Q202.5995 39.114 202.842 39.1339Q203.0846 39.1537 203.2357 39.1855L203.0528 41.4602Q202.9335 41.4204 202.7148 41.4005Q202.4961 41.3806 202.337 41.3806Q201.8678 41.3806 201.4264 41.4999Q200.985 41.6192 200.635 41.8856Q200.2851 42.1521 200.0823 42.5855Q199.8795 43.019 199.8795 43.6473V48.1726H197.4538V39.281H199.2909L199.6488 40.7762H199.7681Q200.0306 40.3229 200.4243 39.9451Q200.8179 39.5673 201.323 39.3406Q201.828 39.114 202.4165 39.114ZM208.4928 39.0981Q210.2822 39.0981 211.2366 39.8775Q212.191 40.6569 212.191 42.2475V48.1726H210.4969L210.0277 46.9637H209.9641Q209.5823 47.4409 209.1847 47.7432Q208.787 48.0454 208.2701 48.1885Q207.7531 48.3317 207.0135 48.3317Q206.2261 48.3317 205.6018 48.0295Q204.9775 47.7272 204.6196 47.1029Q204.2617 46.4786 204.2617 45.5163Q204.2617 44.1006 205.2558 43.4286Q206.25 42.7565 208.2382 42.6849L209.7812 42.6372V42.2475Q209.7812 41.5476 209.4153 41.2216Q209.0495 40.8955 208.3973 40.8955Q207.7531 40.8955 207.1328 41.0784Q206.5124 41.2613 205.8921 41.5397L205.0888 39.9013Q205.7966 39.5275 206.6755 39.3128Q207.5543 39.0981 208.4928 39.0981ZM209.7812 44.0529 208.8427 44.0847Q207.6656 44.1165 207.2083 44.5062Q206.751 44.8959 206.751 45.5322Q206.751 46.0889 207.0771 46.3235Q207.4032 46.5581 207.9281 46.5581Q208.7075 46.5581 209.2443 46.0968Q209.7812 45.6356 209.7812 44.7846ZM217.114 48.1726H214.6883V35.7975H217.114ZM223.3015 39.0981Q225.091 39.0981 226.0454 39.8775Q226.9998 40.6569 226.9998 42.2475V48.1726H225.3057L224.8365 46.9637H224.7729Q224.3911 47.4409 223.9935 47.7432Q223.5958 48.0454 223.0789 48.1885Q222.5619 48.3317 221.8223 48.3317Q221.0349 48.3317 220.4106 48.0295Q219.7862 47.7272 219.4284 47.1029Q219.0705 46.4786 219.0705 45.5163Q219.0705 44.1006 220.0646 43.4286Q221.0587 42.7565 223.047 42.6849L224.59 42.6372V42.2475Q224.59 41.5476 224.2241 41.2216Q223.8583 40.8955 223.2061 40.8955Q222.5619 40.8955 221.9415 41.0784Q221.3212 41.2613 220.7009 41.5397L219.8976 39.9013Q220.6054 39.5275 221.4842 39.3128Q222.3631 39.0981 223.3015 39.0981ZM224.59 44.0529 223.6515 44.0847Q222.4744 44.1165 222.0171 44.5062Q221.5598 44.8959 221.5598 45.5322Q221.5598 46.0889 221.8859 46.3235Q222.212 46.5581 222.7369 46.5581Q223.5163 46.5581 224.0531 46.0968Q224.59 45.6356 224.59 44.7846ZM235.7005 45.5322Q235.7005 46.4388 235.275 47.0632Q234.8495 47.6875 234.0065 48.0096Q233.1635 48.3317 231.9069 48.3317Q230.9763 48.3317 230.3123 48.2124Q229.6482 48.0931 228.9721 47.8147V45.8105Q229.6959 46.1366 230.527 46.3474Q231.3581 46.5581 231.9864 46.5581Q232.6942 46.5581 233.0004 46.3474Q233.3066 46.1366 233.3066 45.7946Q233.3066 45.5719 233.1833 45.393Q233.0601 45.214 232.6545 44.9874Q232.2488 44.7607 231.382 44.3949Q230.5469 44.0449 230.01 43.687Q229.4732 43.3291 229.2147 42.84Q228.9562 42.3509 228.9562 41.5954Q228.9562 40.3626 229.9146 39.7383Q230.873 39.114 232.4795 39.114Q233.3066 39.114 234.0582 39.281Q234.8098 39.448 235.6051 39.8138L234.8734 41.5635Q234.2133 41.2772 233.6287 41.0943Q233.0442 40.9114 232.4397 40.9114Q231.9069 40.9114 231.6365 41.0545Q231.366 41.1977 231.366 41.492Q231.366 41.7067 231.5052 41.8737Q231.6444 42.0407 232.046 42.2435Q232.4477 42.4463 233.2271 42.7645Q233.9826 43.0746 234.5394 43.4127Q235.0961 43.7507 235.3983 44.2477Q235.7005 44.7448 235.7005 45.5322ZM240.0191 39.281V48.1726H237.5934V39.281ZM238.8102 35.7975Q239.351 35.7975 239.7407 36.048Q240.1304 36.2985 240.1304 36.9825Q240.1304 37.6585 239.7407 37.917Q239.351 38.1755 238.8102 38.1755Q238.2614 38.1755 237.8757 37.917Q237.49 37.6585 237.49 36.9825Q237.49 36.2985 237.8757 36.048Q238.2614 35.7975 238.8102 35.7975ZM246.2067 39.0981Q247.9961 39.0981 248.9505 39.8775Q249.9049 40.6569 249.9049 42.2475V48.1726H248.2108L247.7416 46.9637H247.678Q247.2962 47.4409 246.8986 47.7432Q246.5009 48.0454 245.984 48.1885Q245.467 48.3317 244.7274 48.3317Q243.94 48.3317 243.3157 48.0295Q242.6914 47.7272 242.3335 47.1029Q241.9756 46.4786 241.9756 45.5163Q241.9756 44.1006 242.9697 43.4286Q243.9639 42.7565 245.9522 42.6849L247.4951 42.6372V42.2475Q247.4951 41.5476 247.1292 41.2216Q246.7634 40.8955 246.1112 40.8955Q245.467 40.8955 244.8467 41.0784Q244.2263 41.2613 243.606 41.5397L242.8027 39.9013Q243.5105 39.5275 244.3894 39.3128Q245.2682 39.0981 246.2067 39.0981ZM247.4951 44.0529 246.5566 44.0847Q245.3795 44.1165 244.9222 44.5062Q244.4649 44.8959 244.4649 45.5322Q244.4649 46.0889 244.791 46.3235Q245.1171 46.5581 245.642 46.5581Q246.4214 46.5581 246.9582 46.0968Q247.4951 45.6356 247.4951 44.7846ZM260.5383 36.5451Q262.789 36.5451 263.8229 37.5114Q264.8568 38.4777 264.8568 40.1717Q264.8568 40.9352 264.6262 41.6311Q264.3955 42.327 263.8746 42.8679Q263.3537 43.4087 262.4868 43.7228Q261.6199 44.037 260.3474 44.037H259.2896V48.1726H256.8241V36.5451ZM260.411 38.5652H259.2896V42.0169H260.1008Q260.7928 42.0169 261.3018 41.834Q261.8108 41.651 262.0891 41.2613Q262.3675 40.8716 262.3675 40.2592Q262.3675 39.4003 261.8903 38.9827Q261.4131 38.5652 260.411 38.5652ZM270.607 46.3991Q271.0046 46.3991 271.3824 46.3195Q271.7602 46.24 272.134 46.1207V47.9261Q271.7443 48.101 271.1677 48.2164Q270.5911 48.3317 269.9071 48.3317Q269.1118 48.3317 268.4795 48.0732Q267.8472 47.8147 267.4853 47.1745Q267.1235 46.5343 267.1235 45.389V41.1023H265.9623V40.0763L267.2984 39.2651L267.9983 37.3881H269.5492V39.281H272.0385V41.1023H269.5492V45.389Q269.5492 45.898 269.8395 46.1485Q270.1298 46.3991 270.607 46.3991ZM272.6589 39.281H275.3152L276.9933 44.2835Q277.0729 44.5221 277.1286 44.7687Q277.1842 45.0152 277.224 45.2777Q277.2638 45.5401 277.2876 45.8264H277.3353Q277.3831 45.397 277.4666 45.0232Q277.5501 44.6494 277.6773 44.2835L279.3236 39.281H281.9243L278.1625 49.3099Q277.8205 50.2325 277.2717 50.8489Q276.7229 51.4652 276.0111 51.7754Q275.2993 52.0856 274.4483 52.0856Q274.0348 52.0856 273.7325 52.0418Q273.4303 51.9981 273.2156 51.9504V50.0257Q273.3826 50.0655 273.6371 50.0973Q273.8916 50.1291 274.17 50.1291Q274.679 50.1291 275.0448 49.9144Q275.4107 49.6996 275.6572 49.3378Q275.9038 48.9759 276.0469 48.5464L276.1901 48.109ZM287.6188 48.1726V36.5451H290.0843V46.1366H294.8005V48.1726ZM300.3756 46.3991Q300.7733 46.3991 301.1511 46.3195Q301.5289 46.24 301.9027 46.1207V47.9261Q301.5129 48.101 300.9363 48.2164Q300.3597 48.3317 299.6758 48.3317Q298.8805 48.3317 298.2482 48.0732Q297.6159 47.8147 297.254 47.1745Q296.8922 46.5343 296.8922 45.389V41.1023H295.731V40.0763L297.0671 39.2651L297.767 37.3881H299.3179V39.281H301.8072V41.1023H299.3179V45.389Q299.3179 45.898 299.6082 46.1485Q299.8985 46.3991 300.3756 46.3991ZM306.5155 48.3317Q305.0282 48.3317 304.0938 47.1665Q303.1593 46.0014 303.1593 43.7427Q303.1593 41.4602 304.1057 40.2871Q305.0521 39.114 306.5791 39.114Q307.2154 39.114 307.7005 39.2889Q308.1857 39.4639 308.5396 39.7582Q308.8935 40.0524 309.14 40.4183H309.2196Q309.1718 40.1638 309.1042 39.6667Q309.0366 39.1696 309.0366 38.6447V35.7975H311.4703V48.1726H309.6093L309.14 47.0194H309.0366Q308.806 47.3853 308.46 47.6835Q308.1141 47.9817 307.6369 48.1567Q307.1597 48.3317 306.5155 48.3317ZM307.3665 46.3991Q308.3606 46.3991 308.7702 45.8066Q309.1798 45.214 309.2037 44.0211V43.7586Q309.2037 42.4623 308.806 41.7743Q308.4083 41.0864 307.3267 41.0864Q306.5234 41.0864 306.0701 41.7783Q305.6168 42.4702 305.6168 43.7745Q305.6168 45.0788 306.0741 45.739Q306.5314 46.3991 307.3665 46.3991Z",
    fill: "#FFD29E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_875_7375",
    x: 15.7915,
    y: 0.101562,
    width: 19.2927,
    height: 16.7969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_875_7375",
    x: 30.1736,
    y: 0.273438,
    width: 16.3882,
    height: 15.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_875_7375",
    x: 41.5959,
    y: 4.83594,
    width: 15.0881,
    height: 14.7969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_875_7375",
    x: 1.60205,
    y: 9.21875,
    width: 24.1177,
    height: 19.2734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_875_7375",
    x: -0.000244141,
    y: 31.1328,
    width: 27.2043,
    height: 23.4297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_875_7375",
    x: 60.7026,
    y: 50.5781,
    width: 16.1843,
    height: 19.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_875_7375",
    x: 21.7388,
    y: 53.1562,
    width: 23.8267,
    height: 26.6406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_875_7375",
    x: 47.575,
    y: 58.2422,
    width: 18.6997,
    height: 23.9453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_875_7375",
    x: 20.583,
    y: 17.6797,
    width: 90.417,
    height: 35.2969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_7375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_7375",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.3d9bbf003d79a09834216dcc7fc7dcb9.svg";
export { ForwardRef as ReactComponent };